<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-roles :contactPageData='contactPage'></app-roles>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import FrontFooter from '@/components/partials/FrontFooter';
    import {addTask} from '../../config';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    import ListRoleComponent from "@/components/rolePermission/ListRoleComponent";

    export default {
        name: "role",
        mixins: [SessioMixin],
        components: {
            'app-roles': ListRoleComponent,
            'app-footer': FrontFooter,
        },
        data: () => ({
                contactPage: {
                    pageTitle: 'Role List',
                },
                isLoggedIn: false,
            }),
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        mounted: function () {
            var self = this;
            var userObj = localStorage.getItem('filters');
            /* if (userObj != null) {
             userObj = JSON.parse(userObj);
             if (userObj.menurole != null) {
             self.serverParams.columnFilters = userObj.menurole;
             $.map(userObj.menurole, function (val, key) {
             $.each(self.columns, function (i) {
             if (self.columns[i].field == key && val != '') {
             self.columns[i].filterOptions.filterValue = val;
             }
             });
             });
             }
             }*/
            $(".removeActive").removeClass('active');
            $("#menurole").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            // console.log(this.message);
            self.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/rolePermission/ListRole.vue